<template>
    <el-container class="tree_wrap">
        <div class='packUp' ref='packUp' @click='pacjUpFn'>
            <img :src='imgUrl.u95'>
        </div>
        <el-aside :width='asideWidth + "px"'>
            <el-card class="search-form-card">

                <el-input placeholder="输入关键字进行过滤" v-model="filterText" @keyup.enter.native="searchList"></el-input>

                <el-button type="primary" @click='searchList'>搜索</el-button>

                <div class='search-form-card-list' v-if='menuUsefalg'>
                    <ul>
                        <span>
                            <el-link type="info" v-if='menuUseList.app_list.length' :underline="false" @click='moreList("app_list")'>更多应用</el-link>
                        </span>
                        <li v-for='item of menuUseList.app_list' :key='item.id'>
                            <el-link @click='skipPlace("app_list", item)' type="primary" :underline="false">{{item.name}}</el-link>
                        </li>
                    </ul>
                    <ul>
                        <span>
                            <el-link type="info" v-if='menuUseList.folder_list.length' :underline="false" @click='moreList("app_list")'>更多目录</el-link>
                        </span>
                        <li v-for='item of menuUseList.folder_list' :key='item.id'>
                            <el-link @click='skipPlace("folder_list", item)' type="primary" :underline="false">{{item.name}}</el-link>
                        </li>
                    </ul>
                </div>

            </el-card>

            <div class='body-card'>
                <el-card class='body-card-nav'>
                    <div class="AddUse">

                        <!-- 新增应用 -->
                        <router-link  :to="{ path:'/appcenterUseAdd', query: { count: count, callback: forceUpdateFn, parentType: 'add' } }" v-w-role="'ITSM-0100'">
                            <!--v-w-role="'cicdCxjcYysXzyy'"-->
                            <span></span>
                            <el-button type="primary">新增应用</el-button>
                        </router-link>

                        <!-- 新增目录 -->
                        <router-link  :to="{ path:'/appcenterMenuAdd', query: { count: count, callback: forceUpdateFn} }"  v-w-role="'ITSM-0101'">
                            <!--//v-w-role="'cicdCxjcYysXzml'"-->
                            <span></span>
                            <el-button type="primary">新增目录</el-button>
                        </router-link>

                        <!-- 刷新 -->
                        <a @click='forceUpdateFn'>
                            <span></span>
                            <el-button type="primary">刷新</el-button>
                        </a>

                        <!-- 全部收起 -->
                        <a @click='expandFlagfn'>
                            <span></span>
                            <el-button type="primary">全部收起</el-button>
                        </a>

                    </div>
                </el-card>

                <el-card class='body-card-tree'>

                    <el-tree
                        v-if ='update'
                        :props="props1"
                        :load="loadNode1"
                        node-key="id"
                        lazy
                        @node-click="getNodeInfo"
                        :default-expanded-keys="defExpKeys"
                        :filter-node-method="filterNode"

                        ref="tree">

                        <div class="custom-tree-node" slot-scope="{ node, data }" :title='data.name'>
                            <img :src="data.img_url" alt="">

                            <span>{{data.name}}</span>

                        </div>

                    </el-tree>

                </el-card>
            </div>

        </el-aside>

        <el-main v-if='showFlag'>
            <div class='routerView' >
                <el-button
                    v-for='(item, ind) of routerList'
                    :key='ind'
                    type='text'
                    :class='ind !== index? "btn_active": ""'
                    @click='routerPush(ind)'>
                    {{item.name}}
                </el-button>
            </div>
            <div class='routerWrap'>
                <router-view></router-view>
            </div>
        </el-main>

        <el-main v-if='!showFlag'>
            <div class='routerView' >
                <el-button type='text'>目录概述</el-button>
            </div>
            <div class='routerWrap'>
                <router-view></router-view>
            </div>
        </el-main>

    </el-container>
</template>

<script>
    import services from "../cicd.services"

    export default {

        data() {
            return {
                props1: {
                    isLeaf: 'leaf'
                },
                showFlag: false,
                menuUsefalg: false, // 搜索栏是否出现
                menuUseList: {
                    app_list: [],
                    folder_list: []

                }, // 应用 目录 列表
                menuUseListAll: {},
                filterText: '', // input value
                count: {},
                imgUrl: {
                    u95: require('../../../assets/u95.png'),
                },
                update: true,
                asideWidth: 300,
                routerList: [
                    { name: '应用概述', index: '/appcenterTree/useDetail' },
                    { name: '服务器', index: '/appcenterTree/serverList' },
                    // { name: '持续集成', index: 'Integration' }
                ],
                index: '',
                flag: false,
                defExpKeys:[]
            }
        },

        mounted() {
            // console.log(this.type);
            this.showFlag = true
            switch (this.type) {
                case 'detail':
                    // this.count = this.query
                    if (location.href.indexOf("serverList") > -1) {
                        this.index = 1;
                        // this.routerPush(0)
                    }else {
                        this.index = 0;
                    }
                    // this.showFlag = true
                    // this.routerPush(2)
                    break;
                case 'router':
                    this.count = this.query
                    this.index = 2
                    // this.showFlag = true
                    // this.routerPush(1)
                    break;

                default:
                    this.showFlag = false
                    break;
            }
            window.onclick= e => {
                let elArr = e.path.filter(item => item.className === 'search-form-card-list')
                if (!elArr.length) this.menuUsefalg = false
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() { // 环境
                return this.dictionary.env
            },
            server_status() {
                return this.dictionary.server_status
            },
            query() {
                return this.$route.query
            },
            type() {
                return this.query.type
            },
            parentId() {
                return this.query.id
            }
        },

        methods: {
            menudetail(e) {
                e.target.className = ''
                this.$router.push({
                    path: '/appcenterTree/menuDetail',
                    query: {
                        ...this.$route.query
                    }
                })
            },

            // 跳转路由
            routerPush(ind, id) {
                // console.log(this.count,'this.count');
                // console.log(this.type);
                // console.log(this.count,'this.count');
                // console.log(this.type);
                this.index = ind
                switch (this.type) {
                    case 'router':
                        this.$router.push({
                            path: this.routerList[ind].index,
                            query: {
                                ...this.$route.query,
                                id: this.parentId | this.count.id,
                            }
                        })
                        break;
                    case 'detail':
                        // console.log(this.parentId | this.count.id, 'aaaaa')
                        this.$router.push({
                            path: this.routerList[ind].index,
                            query: {
                                // ...this.$router.query,
                                id: this.parentId | this.count.id,
                                type: 'detail'
                            }
                        })
                        break;
                    default:
                          // let query = {
                          //       ...this.$router.query,
                          //       id: this.count.id,
                          //       type: "detail",
                          //       callback:this.forceUpdateFn,
                          //   }
                          //   console.log(query)
                        this.$router.push({
                            path: this.routerList[ind].index,
                            query: {
                                ...this.$route.query,
                                id: this.count.id,
                                type: "detail",
                                callback:this.forceUpdateFn,
                            }
                        })
                        break;
                }
            },

            // 获取树详情
            getNodeInfo(info) {
                // console.log('aaaaa')
                // console.log(info,'info');
                this.getdefExpKeys(info.id)
                // console.log(this.defExpKeys);
                if (this.count.id === info.id) return
                this.count = info
                this.index = 0
                if (info.is_folder) {
                    this.showFlag = false
                    this.$router.push({
                        path: '/appcenterTree/menuDetail',
                        query: {
                            id: info.id,
                            callback: this.forceUpdateFn
                        }
                    })
                } else {
                    this.showFlag = true
                    // this.routerPush(0)
                    this.$router.push({
                        path: '/appcenterTree/useDetail',
                        query: {
                            id: info.id,
                            type: "detail",
                            callback: this.forceUpdateFn
                        }
                    })
                }
            },
            //左侧树形菜单刷新默认展开,保存key
            getdefExpKeys(val){
                // console.log(val);
                // console.log(this.defExpKeys.length);
                if (this.defExpKeys.length){
                    let item= this.defExpKeys.find(i => i==val)
                    // console.log(item);
                    if(!item){
                        this.defExpKeys.push(val)
                    }else{
                        this.defExpKeys.splice(this.defExpKeys.indexOf(item),1)
                    }
                } else{
                    this.defExpKeys.push(val)
                }
            },

            // 点击跳转至某一枝树
            skipPlace(type, item) {
                this.menuUsefalg = false;
                if (item.is_folder) {
                    this.showFlag = false
                    // this.$router.push({
                    //     path: '/appcenterTree/menuDetail',
                    //     query: {
                    //         id: item.id
                    //     }
                    // })
                    // 目录
                } else {
                    this.showFlag = true
                    this.count = item
                    // this.routerPush(0)
                    // 应用
                }
                this.$refs.tree.filter(item)

            },

            // 点击更多应用或目录
            moreList(type) {
                this.menuUseList = {
                    ...this.menuUseList,
                    [type]: this.menuUseListAll[type]
                }
            },

            // 点击搜索应用及目录
            searchList() {
                if (this.filterText) {
                    services.appSearch(this.filterText)
                        .then(res => {
                            this.menuUseListAll = res
                            this.menuUseList = {
                                app_list: res.app_list.slice(0, 4),
                                folder_list: res.folder_list.slice(0, 4)
                            }
                            this.menuUsefalg = true
                            if (!res.app_list.length && !res.folder_list.length) {
                                this.menuUsefalg = false
                            }
                        })
                        .catch(err => this.$message.error(err.message))
                } else {
                    this.menuUsefalg = false
                }
            },

            // 点击收起展开左边框
            pacjUpFn() {
                if (this.asideWidth === 300) {
                    this.asideWidth = 0
                    this.$refs.packUp.className = 'active'
                } else {
                    this.asideWidth = 300
                    this.$refs.packUp.className = 'packUp'
                }
            },

            // 强制刷新页面
            forceUpdateFn() {
                this.update = false
                this.$nextTick(() => this.update = true)
            },

            // 点击全部收起
            expandFlagfn() {
                for(var i=0;i<this.$refs.tree.store._getAllNodes().length;i++){
                    this.$refs.tree.store._getAllNodes()[i].expanded = false;
                }
            },

            // 筛选
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },

            // 请求树
            loadNode1(node, resolve) {
                if (node.level === 0) {
                    services.treeLevel1()
                        .then(response => {
                            let dataTree = response.list.map(item => ({ ...item, leaf: item.is_folder ? false : true, children: item.is_folder && [] }))
                            return resolve(dataTree)
                        })
                        .catch(err => this.$message.error(err.message))
                }
                if (node.level >= 1) this.loadChildren(node, resolve)
            },

            // 获取树子级
            loadChildren(node, resolve) {
                if (!node.data.leaf) {
                    services.treeChildren({ id: node.data.id }).then(response => {
                        let arr = response.list.map(item => {
                            if (node.level === 2) ({ ...item, leaf: true })
                            return { ...item, leaf: item.is_folder ? false : true, children: item.is_folder && [] }
                        })
                        return resolve(arr)
                    })
                }

                return resolve([])
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>

<style lang="scss">
    .body-card-nav {
        .el-card__body {
            padding: 0;
        }
    }
</style>
